import React from 'react'
import { Divider, Grid, Typography } from '@mui/material'
import contactStyle from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";

interface ThreadExecutionTimeLogProps {
    threadExecutionTimeLog: any
} 

const ThreadExecutionTimeLog: React.FC<ThreadExecutionTimeLogProps> = (props) => {
    
    const { threadExecutionTimeLog } = props; 
    const innerHeight = window.innerHeight - 150;
    
    return (
        <>
            <Grid item xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={contactStyle.popupTitleTypography}>Thread Execution Time Log</Typography>
                    </Grid> 

                    <Divider className={contactStyle.popupTitleDivider} /> 
                
                    <Grid item>
                        <Grid container className={`${contactStyle.popupBodyGridContainer} ${styles.customAPILogsManiContainer}`} gap={2} sx={{ maxHeight: `${innerHeight}px !important`}}>

                            {threadExecutionTimeLog ?
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={contactStyle.popupFieldTypography}>Thread Execution Time Log </Typography>
                                        </Grid>
                                        <Grid item xs={12} className={globalStyles.relativePosition}>
                                            <pre className={`${styles.threadExecutionTimeLogPreTag}`}>
                                                {JSON.stringify(threadExecutionTimeLog, null, 4)}
                                            </pre>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                : 
                                <Grid item xs={12}> 
                                    <Typography className={contactStyle.popupFieldTypography}>No execution time log found</Typography>
                                </Grid>
                            }

                        </Grid>
                    </Grid> 
                </Grid> 
            </Grid>  
        </>
    )
}

export default ThreadExecutionTimeLog
